import { AirmeetThemeProvider } from 'context/ThemeProvider';
import moment from 'moment';
import momentdurationformat from 'moment-duration-format'; // must needed for using .format() function with duration()
import React, { Suspense } from 'react';
import Loader from 'components/general/Loader';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './containers/App';
import { AppProvider } from './context/App';
import './i18next';
import store from './store/reducers';
import './wdyr';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

// Script to load webworker from same origin
// https://github.com/GoogleChromeLabs/worker-plugin/issues/36#issuecomment-664970411

if (process.env.REACT_APP_CDN_ASSETS_PATH) {
    (function () {
        var _Worker = window.Worker;
        window.Worker = function (url, opts) {
            if (url.includes(process.env.REACT_APP_CDN_ASSETS_PATH)) {
                const workerPath = `importScripts(${JSON.stringify(url)})`;
                var blob = new Blob([workerPath], {
                    type: 'text/javascript',
                });
                url = URL.createObjectURL(blob);
            }
            return new _Worker(url, opts);
        };
    })();
}

momentdurationformat(moment); // must needed for using .format() function with duration()

moment.updateLocale('en', {
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d secs',
        m: 'a min',
        mm: '%d mins',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    },
});

//TODO: Have App lazy load as well in V2. Right now there are Side Effects
const EmbeddedPageWrapper = React.lazy(() =>
    import('widgets/EmbeddedRegistration/EmbeddedRegistrationPage')
);

ReactDOM.render(
    <Provider store={store}>
        <AirmeetThemeProvider>
            <AppProvider>
                <Suspense fallback={<Loader fullPage={true} type='logo' />}>
                    <BrowserRouter>
                        <Switch>
                            <Route
                                exact
                                path='/widgets/event/:id/embedded-registration'
                                render={(props) => (
                                    <EmbeddedPageWrapper
                                        location={props.location}
                                    />
                                )}
                            ></Route>
                            <Route path='/'>
                                <App />
                            </Route>
                        </Switch>
                    </BrowserRouter>
                </Suspense>
            </AppProvider>
        </AirmeetThemeProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
